import Layout from "components/Layout/AdminDecimetrix";
import SensorOptimization from "components/SensorOptimization";

const Index = () => {
  return (
    <Layout>
      <SensorOptimization />
    </Layout>
  );
};

export default Index;
